import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Shoppingcart, shoppingCartType } from '../../types/slices/shoppingCartType'
import { DocumentOfSale } from '../../types/slices/documentOfSalesType'
import { TypeSale } from '../../types/slices/typeSaleType'
import { WayToPay } from '../../types/slices/wayToPayType'
import { SaleChannel } from '../../types/slices/saleChannelType'

const initialState: shoppingCartType =
{
    status: ApiStatus.FETCHED,
    shoppingcart: [],
    shoppingcartSelected: {} as Shoppingcart,
    productsCount: 0,
    errorMessage: undefined,
    action: '',

    selectedTypeDocument: null,
    selectedSaleChannel: null,
    selectedWayToPay: null,
    folio: ''
}

const shoppingCartSlice = createSlice({
    name: 'shoppingCartSlice',
    initialState,
    reducers: {
        onFetchShoppingCart (state, { payload }: { payload: Shoppingcart[]}) {
            state.status = ApiStatus.FETCHED
            state.shoppingcart = payload
            state.errorMessage = undefined
        },
        onSetSelectedShoppingcart (state, { payload }: { payload: Shoppingcart }) {
            state.shoppingcartSelected = payload
        },
        onSetProductsCount (state, { payload }: { payload: number }) {
            state.productsCount = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
        onSetSelectedTypeDocument (state, { payload }: { payload: DocumentOfSale|null }) {
            state.selectedTypeDocument = payload
        },
        onSetSelectedSaleChannel (state, { payload }: { payload: SaleChannel|null }) {
            state.selectedSaleChannel = payload
        },
        onSetSelectedWayToPay (state, { payload }: { payload: WayToPay|null }) {
            state.selectedWayToPay = payload
        },
        onSetFolio (state, { payload }: { payload: string }) {
            state.folio = payload
        },
    }
})

export const selectShoppingcartState = (state: RootState) => state.shoppingCartSlice
export default shoppingCartSlice.reducer
export const {
    onFetchShoppingCart,
    onSetSelectedShoppingcart,
    onSetProductsCount,
    changeStatus,
    setAction,
    onSetSelectedTypeDocument,
    onSetSelectedSaleChannel,
    onSetSelectedWayToPay,
    onSetFolio
} = shoppingCartSlice.actions
